import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Link,
  Select,
  FormControl,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Copyright } from "../../components";
import { useTranslation } from "react-i18next";

const Layout = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigatorClick = () => {
    if (!user || !user.currentStep) {
      navigate("/");
      return;
    }

    const navigationMap = {
      1: "/BarrierQuestions/:id",
      2: "/ScreeningResults",
      3: "/IdentifiedBarriers",
      4: "/ActionPlan",
    };

    navigate(navigationMap[user.currentStep] || "/");
  };

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value); // Change the app's language dynamically
  };

  const menuItems = user ? (
    <MenuItem
      onClick={() => {
        handleMenuClose();
        navigate("/");
        signOut();
      }}
    >
      {t("signout")} ({user.participantId})
    </MenuItem>
  ) : (
    <MenuItem component={RouterLink} to="/Signin" onClick={handleMenuClose}>
      {t("menu_signin")}
    </MenuItem>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
            }}
          >
            <Link
              component="button"
              onClick={handleNavigatorClick}
              color="inherit"
              underline="none"
            >
              {t("app_name")}
            </Link>
          </Typography>
          <FormControl
            size="small"
            sx={{
              minWidth: 80,
              mr: 2,
            }}
          >
            <Select
              native
              value={i18n.language}
              onChange={handleLanguageChange}
              inputProps={{
                name: "language",
                id: "language-selector",
              }}
              sx={{
                color: "inherit",
                border: 1,
              }}
            >
              <option value="en">English</option>
              <option value="es">Español</option>
            </Select>
          </FormControl>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleMenuOpen}>
            <MenuIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
            {menuItems}
          </Menu>
        </Toolbar>
      </AppBar>
      <Container
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Container>
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: "auto",
          backgroundColor: "background.paper",
        }}
      >
        <Container maxWidth="sm">
          <Copyright />
        </Container>
      </Box>
    </Box>
  );
};

export default Layout;
